import { useResolveRoute } from '@mews/routing';
import { getTaskDetailUrl } from '../../../tasks/actions/routing';
import { ModalLink } from '../../../../components';

const TaskName = ({ name, id }: { name: string; id: string }) => {
    const resolveRoute = useResolveRoute();
    const url = getTaskDetailUrl(resolveRoute)(id);

    return <ModalLink url={url}>{name}</ModalLink>;
};

export default TaskName;
